<template>
  <mdb-card class="pentagon-album animated zoomIn" wide>
    <mdb-view hover cascade>
      <a
        :aria-label="$t('gallery.open_album', { title: album.title })"
        :href="albumPath"
        class="pentagon-album-link"
        @click.prevent="goToAlbum"
      >
        <img
          v-if="album.cover"
          :src="album.cover.thumb"
          :alt="album.cover.alt || album.title"
          :width="album.cover.width"
          :height="album.cover.height"
          class="pentagon-album-cover"
          loading="lazy"
        >
        <span
          v-else
          class="pentagon-album-cover pentagon-album-placeholder"
          aria-hidden="true"
        ></span>
        <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
      </a>
    </mdb-view>
    <mdb-card-body class="text-center pb-0" cascade>

      <mdb-card-title tag="h2" class="h4 pentagon-album-title">
        <strong>{{ album.title }}</strong>
      </mdb-card-title>

      <p v-if="album.caption" class="pentagon-album-caption">
        {{ album.caption }}
      </p>

      <mdb-card-text v-if="album.description">
        {{ album.description }}
      </mdb-card-text>

      <mdb-card-footer class="pentagon-album-footer mt-4">
        <img src="/pentagon-logo.png" class="pentagon-thumb" alt="">
      </mdb-card-footer>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
import {
  mdbCard,
  mdbView,
  mdbMask,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardBody,
} from 'mdbvue';

export default {
  name: 'Album',
  props: {
    // One entry of GET /api/intro/albums.
    album: {
      required: true,
      type: Object,
    },
  },
  components: {
    mdbCard,
    mdbView,
    mdbMask,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardBody,
  },
  computed: {
    albumPath() {
      return this.$router.resolve({ name: 'Album', params: { slug: this.album.slug } }).href;
    },
  },
  methods: {
    goToAlbum() {
      this.$router.push({ name: 'Album', params: { slug: this.album.slug } });
    },
  },
};
</script>

<style>
  .pentagon-album {
    background-color: var(--pentagon-ink-raised);
    border: 1px solid rgba(255, 215, 0, 0.18);
    color: var(--pentagon-parchment);
  }

  .pentagon-album-link {
    display: block;
  }

  .pentagon-album-cover {
    aspect-ratio: 3 / 2;
    display: block;
    height: auto;
    object-fit: cover;
    width: 100%;
  }

  .pentagon-album-placeholder {
    background: var(--pentagon-crimson);
  }

  .pentagon-album-title {
    color: var(--pentagon-gold);
    font-family: var(--pentagon-font-display);
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .pentagon-album-caption {
    font-style: italic;
  }

  .pentagon-album-footer {
    background-color: transparent;
    border-top-color: rgba(255, 215, 0, 0.18);
  }

  .pentagon-thumb {
    height: 25px;
    width: 25px;
  }

  @media (prefers-reduced-motion: reduce) {
    .pentagon-album.animated {
      animation: none;
    }
  }
</style>
